import * as React from 'react';
import { Box } from '@mui/material';
import MutualFundCard from './MutualFundCard';
import { MutualFund } from './types';

const funds: MutualFund[] = [
    {
        id: 'cordros-equity',
        name: 'Cordros Equity Fund',
        manager: 'Cordros',
        nav: 152.34,
        currency: 'NGN',
        risk: 'HIGH',
        ytdReturn: 18.2,
        minInvestment: 5000,
    },
    {
        id: 'arm-balanced',
        name: 'ARM Balanced Fund',
        manager: 'ARM',
        nav: 87.12,
        currency: 'NGN',
        risk: 'MEDIUM',
        ytdReturn: 12.5,
        minInvestment: 10000,
    },
];

const MutualFundsSection: React.FC = () => {
    return (
        <Box sx={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {funds.map((fund) => (
                <Box key={fund.id} sx={{ flex: '1 1 320px', minWidth: 260 }}>
                    <MutualFundCard fund={fund} />
                </Box>
            ))}
        </Box>
    );
};

export default MutualFundsSection;
